import React from "react";
import ContactMain from "../components/ContactMain";

const Contact = () => {
  return <ContactMain />;
};

export default Contact;
